import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import Dashboard from './pages/Dashboard';
import OrbitBoard from './pages/OrbitBoard';
import CalendarView from './pages/CalendarView';
import AssetLibrary from './pages/AssetLibrary';
import Settings from './pages/Settings';
import DemoPage from './pages/DemoPage';

function Layout() {
  const location = useLocation();
  
  const getTitle = () => {
    switch(location.pathname) {
      case '/': return 'Command Center';
      case '/orbit': return 'Campaign Orbit';
      case '/calendar': return 'Content Calendar';
      case '/assets': return 'Asset Library';
      case '/demo': return 'Demo / How It Works';
      case '/settings': return 'Settings';
      default: return 'Dashboard';
    }
  };

  return (
    <div className="flex h-screen bg-[#050505] text-white overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col relative w-full h-full min-w-0">
        <TopBar title={getTitle()} />
        <main className="flex-1 overflow-hidden relative">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/orbit" element={<OrbitBoard />} />
            <Route path="/calendar" element={<CalendarView />} />
            <Route path="/assets" element={<AssetLibrary />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}